<template>
  <component
    :is="server ? 'v-data-table-server' : 'v-data-table'"
    class="default-panel default-content--text"
    :class="[
      {
        'row-pointer': 'onClick:row' in $attrs,
        'hide-items-per-page': hideItemsPerPage,
      },
      `elevation-${elevation}`,
    ]"
    v-bind="tableAttrs"
  >
    <template v-for="(_, slot) in $slots" #[slot]="slotProps">
      <slot :name="slot" v-bind="slotProps || {}" />
    </template>
  </component>
</template>

<script>
export default {
  name: 'BaseDataTable',

  inheritAttrs: false,

  props: {
    elevation: {
      type: [String, Number],
      default: 2,
    },
    /**
     * When true, render v-data-table-server so items-length (API meta.total)
     * drives pagination — plain v-data-table only counts the current page.
     */
    server: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    /**
     * V2 footer-props.disable-items-per-page has no V3 equivalent; callers still
     * pass disable-items-per-page and/or items-per-page-options=[]. Detect that
     * and hide the footer control via .hide-items-per-page CSS.
     */
    hideItemsPerPage() {
      const attrs = this.$attrs;
      const disabled =
        attrs.disableItemsPerPage === true
        || attrs.disableItemsPerPage === ''
        || attrs['disable-items-per-page'] === true
        || attrs['disable-items-per-page'] === '';
      if (disabled) return true;

      const options = attrs.itemsPerPageOptions ?? attrs['items-per-page-options'];
      return Array.isArray(options) && options.length === 0;
    },

    tableAttrs() {
      const attrs = { ...this.$attrs };

      // Strip V2-only footer attrs so they are not forwarded to the DOM.
      delete attrs.disableItemsPerPage;
      delete attrs['disable-items-per-page'];
      delete attrs.itemsPerPageAllText;
      delete attrs['items-per-page-all-text'];

      if (Array.isArray(attrs.headers)) {
        attrs.headers = attrs.headers.map((header) => ({
          ...header,
          title: header.title ?? header.text ?? '',
          key: header.key ?? header.value ?? '',
        }));
      }

      // V3: boolean loading uses props.color (often unset → grey bar).
      // Master V2 used primary blue; pass color via loading string instead of
      // setting table color (which would tint headers/selection).
      if (attrs.loading === true || attrs.loading === '') {
        attrs.loading = 'primary';
      }

      return attrs;
    },
  },
};
</script>
